import { store } from '@/redux/lib/configureStore.js';
import * as userSelectors from '@/redux/selectors/userSelectors.js';
import getPieveSessionCompanyId from '@/lib/auth/getPieveSessionCompanyId.js';
import toSafeString from '@/redux/user/toSafeUserStateString.js';

const getPieveCompanyIdForRequest = () => {
  const sessionCompanyId = toSafeString(getPieveSessionCompanyId());

  if (sessionCompanyId) {
    return sessionCompanyId;
  }

  const reduxCompanyId = toSafeString(userSelectors.activeCompanyId(store.getState()));

  if (reduxCompanyId) {
    return reduxCompanyId;
  }

  return null;
};

export default getPieveCompanyIdForRequest;
